import {createModel} from '@rematch/core';

import {
  fetchSubscriptions,
  requestChangeSubscriptionFrequency,
  requestSubscriptionDelete,
} from '~/services/hot-api/favorites/favorites';
import {Subscription} from '~/services/hot-api/favorites/types';

import type {RootModel} from '.';

export type FavoritesState = {
  subscriptions: {
    items: Subscription[];
  };
};

const defaultState: FavoritesState = {
  subscriptions: {
    items: [],
  },
};

export const favorites = createModel<RootModel>()({
  state: defaultState,
  reducers: {
    setSubscriptions: (state, items: Subscription[]) => ({
      ...state,
      subscriptions: {
        items,
      },
    }),
  },
  effects: (dispatch) => ({
    async loadUserSubscriptions(): Promise<void> {
      try {
        const response = await fetchSubscriptions();

        dispatch.favorites.setSubscriptions(response.data.subscriptions);
      } catch (error) {
        console.error(error);
      }
    },
    async removeSubscription(token: string, state) {
      try {
        await requestSubscriptionDelete(token);

        dispatch.favorites.setSubscriptions(
          state.favorites.subscriptions.items.filter((sub) => sub.unsubscribe_token !== token)
        );
      } catch (error) {
        console.error(error);
      }
    },
    async changeFrequency({id, schedule}: any) {
      try {
        await requestChangeSubscriptionFrequency(id, schedule);
      } catch (error) {
        console.error(error);
      }
    },
  }),
});
